

export default [
    {
        path: 'develop',
        component: resolve => require(['@/views/develop'], resolve),
        name: 'Develop',
        keepAlive: true,
        meta: {
            nav: '开发者平台'
        }
    }
      
]


// WEBPACK FOOTER //
// ./src/router/develop.js